<template>
    <div
      class="fill-height">
      <v-layout wrap>
        <v-flex>
          <section>
            <v-row
              class="px-2">
              <v-col 
                cols="12">
                <v-row>
                  <v-col 
                    cols="12" class="py-0">
                    <v-card
                      class="border-radius"
                      color="#FFFFFF"
                      style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                      <v-card-text
                        class="d-flex align-center">
                        <v-avatar
                          tile
                          size="40">
                          <v-img 
                            alt="amanata" 
                            :src="require('@/assets/icon/statistik.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  color="white">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
  
                        <div
                          class="ml-4 mb-1">
                          <div
                            class="fs-15 black--text"
                            style="font-weight: 600;">
                            Data Statistik Jumlah Program Kegiatan Sub Kegiatan Per OPD
                          </div>
  
                          <div
                            class="fs-13">
                            Periode Tahun {{ filter.year }}
                          </div>
                        </div>
  
                        <v-spacer />
  
                        <div
                          class="d-flex align-center">
                          <div v-if="user.role === 'admin'">
                            <!-- <div class="body-2 mb-2">
                              Pilih Filter
                            </div> -->
  
                            <!-- <v-autocomplete
                              filled
                              rounded
                              dense
  
                              :color="set_color"
                              placeholder="Pilih Filter"
  
                              :items="type"
                              :item-color="set_color"
  
                              hide-details
  
                              clearable
                              @click:clear="filter.type = ''"
  
                              v-model="filter.type"
                              required
                              style="border-radius: 10px; width: 180px;">
                            </v-autocomplete> -->
                          </div>
  
                          <!-- <div v-if="user.role === 'admin' && (new Date(filter.year, filter.month - 1, 1) < new Date(new Date(dpa.perubahan_date).getFullYear(), new Date(dpa.perubahan_date).getMonth(), 1))">
                            <div>
                              <v-autocomplete
                                filled
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Status Anggaran"
  
                                :items="['murni', 'p1']"
                                :item-color="set_color"
                                hide-details
  
  
                                clearable
                                @click:clear="filter.dpa = ''"
  
                                v-model="filter.dpa"
                                required
                                class="mx-1"
                                style="border-radius: 10px; width: 200px;">
                              </v-autocomplete>
                            </div>
                          </div> -->
  
  
                          <v-select
                            filled
                            rounded
                            dense
  
                            :color="set_color"
                            placeholder="Pilih Tahun"
  
                            hide-details
  
                            :items="years"
                            :item-color="set_color"
  
                            v-model="filter.year"
                            style="border-radius: 10px; width: 150px;">
                          </v-select>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
  
                <v-row>
                  <v-col 
                    cols="12" 
                    md="12"
                    class="py-0">
                    <v-card
                      class="border-radius boder-margin-4 my-2"
                      color="#FFFFFF"
                      style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">

                      <div>
                        <v-row class="px-4 pb-2">
                          <!-- MURNI -->
                          <v-col cols="12" md="4">
                            <div class="summary-card summary-murni">
                              <div class="summary-title d-flex align-center" style="color: #1976D2;">
                                <v-chip
                                  x-small
                                  color="blue"
                                  text-color="white"
                                  class="mr-2 px-2">
                                  M
                                </v-chip>
                                Murni
                              </div>
                              <div class="summary-content">
                                <div>
                                  <div class="rounded-circle d-flex align-center justify-center" style="background-color: #1976d23d; padding: 4px; width: 45px; height: 45px;">
                                    <v-icon color="#1976D2" size="24">mdi-file-document-outline</v-icon>
                                  </div>
                                </div>
                                <div>
                                  <div class="summary-sub-title">Program</div>
                                  <div class="summary-value">
                                    {{ programKegiatanSubGrandTotals.murni.program | number }}
                                  </div>
                                </div>
                                <div>
                                  <div class="summary-sub-title">Kegiatan</div>
                                  <div class="summary-value">
                                    {{ programKegiatanSubGrandTotals.murni.kegiatan | number }}
                                  </div>
                                </div>
                                <div>
                                  <div class="summary-sub-title">Sub Kegiatan</div>
                                  <div class="summary-value">
                                    {{ programKegiatanSubGrandTotals.murni.sub | number }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </v-col>

                          <!-- P1 -->
                          <v-col cols="12" md="4">
                            <div class="summary-card summary-p1">
                              <div class="summary-title d-flex align-center" style="color: #FF9800;">
                                <v-chip
                                  x-small
                                  color="orange"
                                  text-color="white"
                                  class="mr-2 px-2">
                                  P1
                                </v-chip>
                                P1
                              </div>
                              <div class="summary-content">
                                <div>
                                  <div class="rounded-circle d-flex align-center justify-center" style="background-color: #ff98003d; padding: 4px; width: 45px; height: 45px;">
                                    <v-icon color="#FF9800" size="24">mdi-file-document-outline</v-icon>
                                  </div>
                                </div>
                                <div>
                                  <div class="summary-sub-title">Program</div>
                                  <div class="summary-value">
                                    {{ programKegiatanSubGrandTotals.p1.program | number }}
                                  </div>
                                </div>
                                <div>
                                  <div class="summary-sub-title">Kegiatan</div>
                                  <div class="summary-value">
                                    {{ programKegiatanSubGrandTotals.p1.kegiatan | number }}
                                  </div>
                                </div>
                                <div>
                                  <div class="summary-sub-title">Sub Kegiatan</div>
                                  <div class="summary-value">
                                    {{ programKegiatanSubGrandTotals.p1.sub | number }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </v-col>

                          <!-- PERUBAHAN -->
                          <v-col cols="12" md="4">
                            <div class="summary-card summary-perubahan">
                              <div class="summary-title d-flex align-center" style="color: #4CAF50;">
                                <v-chip
                                  x-small
                                  color="green"
                                  text-color="white"
                                  class="mr-2 px-2">
                                  P
                                </v-chip>
                                Perubahan
                              </div>
                              <div class="summary-content">
                                <div>
                                  <div class="rounded-circle d-flex align-center justify-center" style="background-color: #4caf503d; padding: 4px; width: 45px; height: 45px;">
                                    <v-icon color="#4CAF50" size="24">mdi-file-document-outline</v-icon>
                                  </div>
                                </div>
                                <div>
                                  <div class="summary-sub-title">Program</div>
                                  <div class="summary-value">
                                    {{ programKegiatanSubGrandTotals.perubahan.program | number }}
                                  </div>
                                </div>
                                <div>
                                  <div class="summary-sub-title">Kegiatan</div>
                                  <div class="summary-value">
                                    {{ programKegiatanSubGrandTotals.perubahan.kegiatan | number }}
                                  </div>
                                </div>
                                <div>
                                  <div class="summary-sub-title">Sub Kegiatan</div>
                                  <div class="summary-value">
                                    {{ programKegiatanSubGrandTotals.perubahan.sub | number }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                    
                    <v-card
                      class="border-radius boder-margin-4"
                      flat
                      color="#FFFFFF"
                      style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                      <div class="px-3 pb-4">
                        <v-row class="mt-0">
                          <v-col cols="12">
                            <v-card
                              class=""
                              flat
                              color="#FFFFFF"
                              style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                              <v-skeleton-loader
                                class="ma-auto"
                                :loading="process.load"
                                type="table">
                                <v-card-text class="pb-2">
                                  <div class="d-flex align-center flex-wrap">
                                    <div>
                                      <div
                                        class="fs-14 black--text card-title-enhanced"
                                        style="margin-bottom: 3px;">
                                        Rincian per OPD
                                      </div>
                                      <div
                                        class="fs-12"
                                        style="opacity: 70%;">
                                        Sumber data: jumlah program, kegiatan, dan sub kegiatan tiap OPD
                                      </div>
                                    </div>
                                    <v-spacer />
                                    <div class="d-flex flex-wrap caption grey--text text--darken-1">
                                      <span class="mr-3">
                                        <v-chip
                                          x-small
                                          color="blue"
                                          text-color="white"
                                          class="mr-1">
                                          M
                                        </v-chip>
                                        Murni
                                      </span>
                                      <span class="mr-3">
                                        <v-chip
                                          x-small
                                          color="orange"
                                          text-color="white"
                                          class="mr-1">
                                          P1
                                        </v-chip>
                                        Perubahan pertama
                                      </span>
                                      <span>
                                        <v-chip
                                          x-small
                                          color="green"
                                          text-color="white"
                                          class="mr-1">
                                          P
                                        </v-chip>
                                        Perubahan
                                      </span>
                                    </div>
                                  </div>
                                </v-card-text>

                                <div class="px-4 pb-4 opd-pk-table-wrap">
                                  <v-simple-table
                                    v-if="list_program_kegiatan_sub_per_opd.length"
                                    dense
                                    class="opd-pk-table">
                                    <template v-slot:default>
                                      <thead>
                                        <tr>
                                          <th
                                            rowspan="2"
                                            class="text-left opd-pk-th-unit">
                                            No
                                          </th>
                                          <th
                                            rowspan="2"
                                            class="text-left opd-pk-th-unit">
                                            OPD
                                          </th>
                                          <th
                                            rowspan="2"
                                            class="text-left opd-pk-th-unit">
                                            Anggaran Murni
                                          </th>
                                          <th
                                            rowspan="2"
                                            class="text-left opd-pk-th-unit">
                                            Anggaran P1
                                          </th>
                                          <th
                                            rowspan="2"
                                            class="text-left opd-pk-th-unit">
                                            Anggaran Perubahan
                                          </th>
                                          <th
                                            colspan="3"
                                            class="text-center opd-pk-th-group opd-pk-murni">
                                            Murni
                                          </th>
                                          <th
                                            colspan="3"
                                            class="text-center opd-pk-th-group opd-pk-p1">
                                            P1
                                          </th>
                                          <th
                                            colspan="3"
                                            class="text-center opd-pk-th-group opd-pk-perubahan">
                                            Perubahan
                                          </th>
                                        </tr>
                                        <tr>
                                          <th class="text-right opd-pk-th-sub opd-pk-murni">
                                            Program
                                          </th>
                                          <th class="text-right opd-pk-th-sub opd-pk-murni">
                                            Kegiatan
                                          </th>
                                          <th class="text-right opd-pk-th-sub opd-pk-murni">
                                            Sub
                                          </th>
                                          <th class="text-right opd-pk-th-sub opd-pk-p1">
                                            Program
                                          </th>
                                          <th class="text-right opd-pk-th-sub opd-pk-p1">
                                            Kegiatan
                                          </th>
                                          <th class="text-right opd-pk-th-sub opd-pk-p1">
                                            Sub
                                          </th>
                                          <th class="text-right opd-pk-th-sub opd-pk-perubahan">
                                            Program
                                          </th>
                                          <th class="text-right opd-pk-th-sub opd-pk-perubahan">
                                            Kegiatan
                                          </th>
                                          <th class="text-right opd-pk-th-sub opd-pk-perubahan">
                                            Sub
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          v-for="(row, idx) in list_program_kegiatan_sub_per_opd"
                                          :key="row.unit_id || idx">
                                          <td class="text-left">
                                            {{ idx + 1 }}
                                          </td>
                                          <td class="text-left font-weight-medium">
                                            {{ row.unit_name || '—' }}
                                          </td>
                                          <td class="text-right">
                                            {{ row.murni.anggaran_murni || 0 | number }}
                                          </td>
                                          <td class="text-right">
                                            {{ row.p1.anggaran_p1 || 0 | number }}
                                          </td>
                                          <td class="text-right">
                                            {{ row.perubahan.anggaran_perubahan || 0 | number }}
                                          </td>
                                          <td class="text-right">
                                            <template v-if="getOpdPkSub(row, 'murni', 'program') === null">-</template>
                                            <template v-else>{{ getOpdPkSub(row, 'murni', 'program') | number }}</template>
                                          </td>
                                          <td class="text-right">
                                            <template v-if="getOpdPkSub(row, 'murni', 'kegiatan') === null">-</template>
                                            <template v-else>{{ getOpdPkSub(row, 'murni', 'kegiatan') | number }}</template>
                                          </td>
                                          <td class="text-right">
                                            <template v-if="getOpdPkSub(row, 'murni', 'sub') === null">-</template>
                                            <template v-else>{{ getOpdPkSub(row, 'murni', 'sub') | number }}</template>
                                          </td>
                                          <td class="text-right">
                                            <template v-if="getOpdPkSub(row, 'p1', 'program') === null">-</template>
                                            <template v-else>{{ getOpdPkSub(row, 'p1', 'program') | number }}</template>
                                          </td>
                                          <td class="text-right">
                                            <template v-if="getOpdPkSub(row, 'p1', 'kegiatan') === null">-</template>
                                            <template v-else>{{ getOpdPkSub(row, 'p1', 'kegiatan') | number }}</template>
                                          </td>
                                          <td class="text-right">
                                            <template v-if="getOpdPkSub(row, 'p1', 'sub') === null">-</template>
                                            <template v-else>{{ getOpdPkSub(row, 'p1', 'sub') | number }}</template>
                                          </td>
                                          <td class="text-right">
                                            <template v-if="getOpdPkSub(row, 'perubahan', 'program') === null">-</template>
                                            <template v-else>{{ getOpdPkSub(row, 'perubahan', 'program') | number }}</template>
                                          </td>
                                          <td class="text-right">
                                            <template v-if="getOpdPkSub(row, 'perubahan', 'kegiatan') === null">-</template>
                                            <template v-else>{{ getOpdPkSub(row, 'perubahan', 'kegiatan') | number }}</template>
                                          </td>
                                          <td class="text-right">
                                            <template v-if="getOpdPkSub(row, 'perubahan', 'sub') === null">-</template>
                                            <template v-else>{{ getOpdPkSub(row, 'perubahan', 'sub') | number }}</template>
                                          </td>
                                        </tr>
                                        <!-- <tr
                                          v-if="list_program_kegiatan_sub_per_opd.length"
                                          class="opd-pk-total-row font-weight-medium">
                                          <td
                                            colspan="2"
                                            class="text-left">
                                            Jumlah
                                          </td>
                                          <td class="text-right">
                                            {{ programKegiatanSubGrandTotals.murni.program | number }}
                                          </td>
                                          <td class="text-right">
                                            {{ programKegiatanSubGrandTotals.murni.kegiatan | number }}
                                          </td>
                                          <td class="text-right">
                                            {{ programKegiatanSubGrandTotals.murni.sub | number }}
                                          </td>
                                          <td class="text-right">
                                            {{ programKegiatanSubGrandTotals.p1.program | number }}
                                          </td>
                                          <td class="text-right">
                                            {{ programKegiatanSubGrandTotals.p1.kegiatan | number }}
                                          </td>
                                          <td class="text-right">
                                            {{ programKegiatanSubGrandTotals.p1.sub | number }}
                                          </td>
                                          <td class="text-right">
                                            {{ programKegiatanSubGrandTotals.perubahan.program | number }}
                                          </td>
                                          <td class="text-right">
                                            {{ programKegiatanSubGrandTotals.perubahan.kegiatan | number }}
                                          </td>
                                          <td class="text-right">
                                            {{ programKegiatanSubGrandTotals.perubahan.sub | number }}
                                          </td>
                                        </tr> -->
                                      </tbody>
                                    </template>
                                  </v-simple-table>

                                  <div
                                    v-else
                                    class="text-center py-8 grey--text body-2">
                                    Belum ada data OPD untuk periode ini.
                                  </div>
                                </div>
                              </v-skeleton-loader>
                            </v-card>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
  
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  // import { filter } from "core-js/core/array";
    export default {
      data() {
        return {
          dialog: {
            warning: false
          },
          clock: {
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            time: ''
          },
          getMonth: new Date().getMonth(),
  
          type: ['Asisten', 'Sekda', 'Dinas Pendidikan', 'Kecamatan', 'Dinas Kesehatan', 'Semua Kecamatan', 'Semua Kelurahan', 'Semua Puskesmas'],
  
          category: ['OPD', 'Gabungan'],
  
          asistensi: ['Asisten Administrasi Umum', 'Asisten Perekonomian dan Pembangunan', 'Asisten Pemerintahan dan Kesejahteraan Rakyat'],
  
          filter: {
            tahun_anggaran: new Date().getFullYear(),
            year: new Date().getFullYear(),
            month: 12,
            month_text: new Date().toLocaleString('id', { month: 'long' }),
            unit_id: '',
            unit_title: '',
            unit_type: '',
            asistensi: '',
            kecamatan_id: '',
            kecamatan_title: '',
            type: '',
            category: '',
            is_pengecualian: '1',
            dpa: 'murni'
          },
          filter_data: {
            unit: [],
            kecamatan: [
              {
                name: 'KECAMATAN KLATEN TENGAH',
                id: '42,326,327,328,330,329,325'
              },
              {
                name: 'KECAMATAN KLATEN UTARA',
                id: '43,334,335'
              },
              {
                name: 'KECAMATAN KLATEN SELATAN',
                id: '41,313'
              },
              {
                name: 'KECAMATAN JATINOM',
                id: '32,179'
              }
            ]
          },
          bulan: [
            {
              text: 'Januari',
              value: 1
            },
            {
              text: 'Februari',
              value: 2
            },
            {
              text: 'Maret',
              value: 3
            },
            {
              text: 'April',
              value: 4
            },
            {
              text: 'Mei',
              value: 5
            },
            {
              text: 'Juni',
              value: 6
            },
            {
              text: 'Juli',
              value: 7
            },
            {
              text: 'Agustus',
              value: 8
            },
            {
              text: 'September',
              value: 9
            },
            {
              text: 'Oktober',
              value: 10
            },
            {
              text: 'November',
              value: 11
            },
            {
              text: 'Desember',
              value: 12
            }
          ],
          unit: [],
          detail: {},
          detailPerubahan: {},
          detailP1: {},

          list_program_kegiatan_sub_per_opd: [],
  
          list: {
            data: [],
            summary: {},
            realisasi: {},
            deviasi: {},
            realisasiP1: {},
            deviasiP1: {},
  
            count: [
              {
                name: 'Total Anggaran',
                total: 0,
                icon: require('@/assets/icon/budget.png'),
                sub: []
              },
              {
                name: 'Realisasi Keuangan',
                total: 0,
                icon: require('@/assets/icon/dash_kegiatan.png'),
                sub: []
              },
              {
                name: 'Deviasi',
                total: 0,
                icon: require('@/assets/icon/percent.png'),
                sub: []
              },
              {
                name: 'Rata-Rata Target Fisik',
                total: 0,
                icon: require('@/assets/icon/average_target_fisik_format.png'),
                sub: []
              },
              {
                name: 'Persentase Anggaran SP2D',
                total: 0,
                icon: require('@/assets/icon/total_persentase_sp2d.png'),
                sub: []
              },
              {
                name: 'Persentase SP2D',
                total: 0,
                icon: require('@/assets/icon/total_persentase_sp2d_anggaran.png'),
                sub: []
              }
            ],
  
            program: [],
  
            persentase: {
              name: 'Persentase Pekerjaan',
              icon: require('@/assets/icon/dash_persen.png'),
              pie: {
                series: [44, 55, 13, 43, 22],
                chartOptions: {
                  chart: {
                    width: 380,
                    type: 'pie',
                  },
                  labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
                  responsive: [{
                    breakpoint: 480,
                    options: {
                      chart: {
                        width: 200
                      },
                      legend: {
                        position: 'bottom'
                      }
                    }
                  }]
                }
              }
            },
            dataPerubahan: [],
            realisasiPerubahan: {},
            deviasiPerubahan: {},
          },
          
          process: {
            load: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      watch: {
        'filter.type': function () {
          let t = this
          t.filter.asistensi = ''
          t.filter.unit_id = ''
          t.filter.kecamatan_id = ''
          if (t.filter.type === 'Asisten' || t.filter.type === 'Kacamatan') {
            // t.filter.asistensi = 'Asisten Administrasi Umum'
          } else {
            this.fetch()
          }
        },
  
        'filter.asistensi': function () {
          let t = this
  
          t.filter.asistensi === null ? t.filter.asistensi = '' : ''
  
          // let u = this.filter_data.unit.filter(function(v) {
          //   return t.filter.unit_id == v.id
          // })
  
          // if (u.length > 0) {
          //   this.filter.unit_title = u[0].title
          // }
          this.fetch()
        },
  
        'filter.is_pengecualian': function () {
          let t = this
  
          t.filter.is_pengecualian === null ? t.filter.is_pengecualian = '' : ''
  
          // let u = this.filter_data.unit.filter(function(v) {
          //   return t.filter.unit_id == v.id
          // })
  
          // if (u.length > 0) {
          //   this.filter.unit_title = u[0].title
          // }
          this.fetch()
        },
  
        'filter.unit_id': function () {
          let t = this
  
          t.filter.unit_id === null ? t.filter.unit_id = '' : ''
  
          let u = this.filter_data.unit.filter(function(v) {
            return t.filter.unit_id == v.id
          })
  
          if (u.length > 0) {
            this.filter.unit_title = u[0].title
            this.filter.unit_type = u[0].type
          }
          this.fetch()
        },
  
        'filter.kecamatan_id': function () {
          let t = this
  
          t.filter.kecamatan_id === null ? t.filter.kecamatan_id = '' : ''
  
          let u = this.filter_data.kecamatan.filter(function(v) {
            return t.filter.kecamatan_id == v.id
          })
  
          if (u.length > 0) {
            this.filter.kecamatan_title = u[0].name
          }
          this.fetch()
        },
        'filter.year': function () {
          this.fetchDpa()
        },
        'filter.month': function () {
          this.filter.month_text = ''
          this.bulan.map((v, i) => {
            if (v.value === this.filter.month) {
              this.filter.month_text = v.text
            }
          })
          this.fetch()
        },
        'filter.dpa': function () {
          this.fetch()
        },
      },
      computed: {
        rps() {
          return this.$vuetify.breakpoint.name
        },
        user () {
          return this.$store.state.user
        },
        dpa () {
          return this.$store.state.dpa
        },
        company () {
          return this.$store.state.company
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r+93}, ${g+120}, ${b+12})`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
        set_color_rgb_soft () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.05)`
        },
  
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
  
        years () {
          let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []
  
          this.filter.year = this.$store.state.year
  
          for (let i = max; i >= min; i--) {
            years.push({
              text: i,
              value: i
            })
          }
  
          return years
        },
        months () {
          let numb = new Date().getMonth() + 1
          
          this.filter.month = numb
  
          this.filter.month_text = new Date().toLocaleString('id', { month: 'long' })
  
          return [
            {
              text: 'Januari',
              value: 1
            },
            {
              text: 'Februari',
              value: 2
            },
            {
              text: 'Maret',
              value: 3
            },
            {
              text: 'April',
              value: 4
            },
            {
              text: 'Mei',
              value: 5
            },
            {
              text: 'Juni',
              value: 6
            },
            {
              text: 'Juli',
              value: 7
            },
            {
              text: 'Agustus',
              value: 8
            },
            {
              text: 'September',
              value: 9
            },
            {
              text: 'Oktober',
              value: 10
            },
            {
              text: 'November',
              value: 11
            },
            {
              text: 'Desember',
              value: 12
            }
          ]
        },
        // Computed untuk menentukan periode DPA
        dpaPeriods () {
          if (!this.dpa || !this.dpa.tahun) return null
          
          const murniDate = this.dpa.murni_date ? new Date(this.dpa.murni_date) : null
          const p1Date = this.dpa.p1_date ? new Date(this.dpa.p1_date) : null
          const perubahanDate = this.dpa.perubahan_date ? new Date(this.dpa.perubahan_date) : null
          
          return {
            murniStart: murniDate,
            murniEnd: p1Date || perubahanDate,
            p1Start: p1Date,
            p1End: perubahanDate,
            perubahanStart: perubahanDate
          }
        },
        // Menentukan bulan terakhir untuk setiap periode
        lastMurniMonth () {
          if (!this.dpaPeriods || !this.dpaPeriods.murniEnd) return null
          // Bulan terakhir murni adalah bulan sebelum murniEnd
          // Jika murniEnd adalah April (bulan 3, 0-based), maka bulan terakhir murni adalah Maret (bulan 2, 0-based)
          const endMonth = this.dpaPeriods.murniEnd.getMonth()
          return endMonth > 0 ? endMonth - 1 : 11 // Jika bulan 0 (Januari), kembali ke Desember (bulan 11)
        },
        lastP1Month () {
          if (!this.dpaPeriods || !this.dpaPeriods.p1End) return null
          // Bulan terakhir P1 adalah bulan sebelum p1End
          const endMonth = this.dpaPeriods.p1End.getMonth()
          return endMonth > 0 ? endMonth - 1 : 11 // Jika bulan 0 (Januari), kembali ke Desember (bulan 11)
        },
        // Menentukan apakah bulan yang dipilih dalam periode tertentu
        isInMurniPeriod () {
          if (!this.dpaPeriods || !this.dpaPeriods.murniStart) return false
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const murniStart = new Date(this.dpaPeriods.murniStart.getFullYear(), this.dpaPeriods.murniStart.getMonth(), 1)
          const murniEnd = this.dpaPeriods.murniEnd ? new Date(this.dpaPeriods.murniEnd.getFullYear(), this.dpaPeriods.murniEnd.getMonth(), 1) : null
          
          return selectedDate >= murniStart && (!murniEnd || selectedDate < murniEnd)
        },
        isInP1Period () {
          if (!this.dpaPeriods || !this.dpaPeriods.p1Start) return false
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const p1Start = new Date(this.dpaPeriods.p1Start.getFullYear(), this.dpaPeriods.p1Start.getMonth(), 1)
          const p1End = this.dpaPeriods.p1End ? new Date(this.dpaPeriods.p1End.getFullYear(), this.dpaPeriods.p1End.getMonth(), 1) : null
          
          return selectedDate >= p1Start && (!p1End || selectedDate < p1End)
        },
        isInPerubahanPeriod () {
          if (!this.dpaPeriods || !this.dpaPeriods.perubahanStart) return false
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const perubahanStart = new Date(this.dpaPeriods.perubahanStart.getFullYear(), this.dpaPeriods.perubahanStart.getMonth(), 1)
          
          return selectedDate >= perubahanStart
        },
        programKegiatanSubGrandTotals () {
          const empty = () => ({
            murni: { program: 0, kegiatan: 0, sub: 0 },
            p1: { program: 0, kegiatan: 0, sub: 0 },
            perubahan: { program: 0, kegiatan: 0, sub: 0 }
          })
          const totals = empty()
          const periods = ['murni', 'p1', 'perubahan']
          const fields = ['program', 'kegiatan', 'sub']
          const rows = this.list_program_kegiatan_sub_per_opd || []
          rows.forEach((row) => {
            periods.forEach((p) => {
              const block = row[p]
              if (!block || typeof block !== 'object') return
              fields.forEach((f) => {
                const n = Number(block[f])
                if (Number.isFinite(n)) totals[p][f] += n
              })
            })
          })
          return totals
        }
      },
      mounted () {
        setInterval(this.updateTime, 1000)
        
        this.fetchDpa()
        // this.fetch()
  
        this.fetchUnit()
      },
      methods: {
        async fetchDpa () {
          let params = {
            tahun:  this.filter.year
          }
          await get('admin/dpa/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
  
              TokenService.saveDpa(JSON.stringify(res.results.data[0]))
  
              this.$store.commit("setDpa", res.results.data[0])
              this.fetchProgramPerUnitAllStatus()
              
            }
          })
        },
        async fetchUnit () {
          let params = {
            limit: 100000,
            year: new Date().getFullYear()
          }
  
          await get('admin/unit/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.unit = res.results.data
              this.fetchProgramPerUnitAllStatus()
            }
          })
        },
        getFetchConfig() {
  if (this.isInPerubahanPeriod) {
    return {
      status: 'perubahan',
      month: this.getPerubahanMonthForFetch()
    }
  }

  if (this.isInP1Period) {
    return {
      status: 'p1',
      month: this.getP1MonthForFetch()
    }
  }

  if (this.isInMurniPeriod) {
    return {
      status: 'murni',
      month: this.getMurniMonthForFetch()
    }
  }

  return {
    status: 'murni',
    month: this.filter.month
  }
},

getFetchConfigByStatus(status) {
  if (status === 'murni') {
    return {
      status: 'murni',
      month: this.getMurniMonthForFetch()
    }
  }

  if (status === 'p1') {
    return {
      status: 'p1',
      month: this.getP1MonthForFetch()
    }
  }

  if (status === 'perubahan') {
    return {
      status: 'perubahan',
      month: this.getPerubahanMonthForFetch()
    }
  }

  return null
},
async fetchProgramPerUnitAllStatus() {
  // this.filter.month = 12
  // this.filter.year = 2025
  this.process.load = true
  this.list_program_kegiatan_sub_per_opd = []

  try {
    const units = this.unit || []
    const statuses = ['murni', 'p1', 'perubahan']

    const promises = units.map(async (u) => {
      let result = {
        unit_id: u.id,
        unit_name: u.name || u.title,
        murni: {},
        p1: {},
        perubahan: {}
      }

      for (const status of statuses) {
        const config = this.getFetchConfigByStatus(status)

        if (!config || !config.month) continue

        try {
          const params = {
            unit_id: u.id,
            tahun_anggaran: this.filter.year,
            year: this.filter.year,
            month: config.month,
            dpa_status: config.status
          }

          const res = await get('admin/dashboard/data', { params })

          if (res.data.status === 200) {
            const data = res.data.results

            result[status] = {
              program: data.total_program || 0,
              kegiatan: data.total_kegiatan || 0,
              sub: data.total_sub_kegiatan || 0,
              anggaran_murni: data.pagu_anggaran || 0,
              anggaran_p1: data.pagu_anggaran_p1 || 0,
              anggaran_perubahan: data.pagu_anggaran_perubahan || 0
            }
          }

        } catch (err) {
          console.error(`Error ${status} unit ${u.id}`, err)
        }
      }

      return result
    })

    const results = await Promise.all(promises)

    this.list_program_kegiatan_sub_per_opd = results
    console.log(this.list_program_kegiatan_sub_per_opd)

  } catch (err) {
    console.error(err)
  }

  this.process.load = false
},
        async fetch () {
          this.process.load = true
  
          // Tentukan bulan yang tepat untuk fetch data murni
          const murniMonth = this.getMurniMonthForFetch()
          if (murniMonth === null) {
            // Jika tidak ada data murni, set default dan lanjutkan
            this.detail = {}
            this.fetchRealisasi()
            return
          }
  
          this.fetchRealisasi()
        },
  
        async fetchRealisasi () {
          this.process.load = true

          // Tentukan bulan yang tepat untuk fetch data murni
          const murniMonth = this.getMurniMonthForFetch()
          if (murniMonth === null) {
            this.fetchP1()
            return
          }

          let params = {
            unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
            unit_asisten: this.filter.asistensi,
            gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
            gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

            tahun_anggaran: this.filter.year,
            is_pengecualian: this.filter.is_pengecualian,

            year: this.filter.year,
            month: murniMonth,
            dpa_status: 'murni'
          }

          await get('admin/dashboard/sub_kegiatan_group', { params })
          .then(response => {
            let res = response.data
              
            // this.process.load = false

            if (res.status === 200) {
              
              let data = res.results

              this.list.realisasi = data.realisasi_fisik
              this.list.deviasi = data.deviasi
              this.fetchP1()
              // this.detail = data
            }
          })
        },
  
        async fetchP1 () {
          this.process.load = true
  
          // Tentukan bulan yang tepat untuk fetch data P1
          const p1Month = this.getP1MonthForFetch()
          if (p1Month === null) {
            // Jika tidak ada data P1, set default dan lanjutkan
            this.detailP1 = {}
            this.fetchRealisasiP1()
            return
          }
  
          this.fetchRealisasiP1()
        },
  
        async fetchRealisasiP1 () {
          this.process.load = true
  
          // Tentukan bulan yang tepat untuk fetch data P1
          const p1Month = this.getP1MonthForFetch()
          if (p1Month === null) {
            this.fetchPerubahan()
            return
          }
  
          let params = {
            unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
            unit_asisten: this.filter.asistensi,
            gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
            gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',
  
            tahun_anggaran: this.filter.year,
            is_pengecualian: this.filter.is_pengecualian,
  
            year: this.filter.year,
            month: p1Month,
            dpa_status: 'p1'
          }
  
          await get('admin/dashboard/sub_kegiatan_group', { params })
          .then(response => {
            let res = response.data
              
            // this.process.load = false
  
            if (res.status === 200) {
              
              let data = res.results
  
              this.list.realisasiP1 = data.realisasi_fisik
              this.list.deviasiP1 = data.deviasi
              // console.log(this.filter.year, this.filter.month)
              // if(this.filter.year === 2025 && (this.filter.month === 4 || this.filter.month === 5 || this.filter.month === 6 || this.filter.month === 7)) {
                this.list.realisasi = data.realisasi_fisik
                this.list.deviasi = data.deviasi
              // }
              this.fetchPerubahan()
              // this.detail = data
            }
          })
        },
  
        async fetchPerubahan () {
          this.process.load = true
  
          // Tentukan bulan yang tepat untuk fetch data perubahan
          const perubahanMonth = this.getPerubahanMonthForFetch()
          if (perubahanMonth === null) {
            // Jika tidak ada data perubahan, set default dan lanjutkan
            this.detailPerubahan = {}
            this.fetchRealisasiPerubahan()
            return
          }
  
          this.fetchRealisasiPerubahan()
        },
  
        async fetchRealisasiPerubahan () {
          this.process.load = true
  
          // Tentukan bulan yang tepat untuk fetch data perubahan
          const perubahanMonth = this.getPerubahanMonthForFetch()
          if (perubahanMonth === null) {
            this.process.load = false
            return
          }
  
          let params = {
  
            unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
            unit_asisten: this.filter.asistensi,
            gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
            gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',
  
            tahun_anggaran: this.filter.year,
            is_pengecualian: this.filter.is_pengecualian,
  
            year: this.filter.year,
            month: perubahanMonth,
            dpa_status: 'perubahan'
          }
  
          await get('admin/dashboard/sub_kegiatan_group', { params })
          .then(response => {
            let res = response.data
              
            this.process.load = false
  
            if (res.status === 200) {
              
              let data = res.results
  
              this.list.realisasiPerubahan = data.realisasi_fisik
              this.list.deviasiPerubahan = data.deviasi
              // if(this.filter.year === 2025 && (this.filter === 4 || this.filter === 5 || this.filter === 6 || this.filter === 7)) {
              //   // this.list.realisasi = data.realisasi_fisik
              //   // this.list.deviasi = data.deviasi
              // } else {
              // if(new Date(this.filter.year, this.filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1) === false) {
              // }
              this.list.realisasi = data.realisasi_fisik
              this.list.deviasi = data.deviasi
            }
              // this.detail = data
            // }
          })
        },
  
        updateTime () {
          let cd = new Date()
  
          this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
        },
        zeroPadding (num, digit) {
          let zero = ''
  
          for(let i = 0; i < digit; i++) {
            zero += '0'
          }
          return (zero + num).slice(-digit)
        },
        // Helper methods untuk mendapatkan nilai berdasarkan periode
        getMurniValue (field) {
          // Jika bulan yang dipilih sebelum periode murni dimulai
          if (!this.dpaPeriods || !this.dpaPeriods.murniStart) {
            return '-'
          }
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const murniStart = new Date(this.dpaPeriods.murniStart.getFullYear(), this.dpaPeriods.murniStart.getMonth(), 1)
          
          if (selectedDate < murniStart) {
            return '-'
          }
          
          // Jika dalam periode murni, tampilkan data bulan tersebut
          if (this.isInMurniPeriod) {
            return this.detail[field] || 0
          }
          
          // Jika tidak dalam periode murni (sudah masuk P1 atau Perubahan), 
          // tampilkan data dari bulan terakhir murni
          // Kita perlu mengambil data dari bulan terakhir murni, bukan bulan yang dipilih
          // Untuk sekarang, kita akan menggunakan data dari detail (yang seharusnya sudah sesuai)
          return this.detail[field] || 0
        },
        getP1Value (field) {
          // Jika bulan yang dipilih sebelum periode P1 dimulai atau P1 tidak ada
          if (!this.dpaPeriods || !this.dpaPeriods.p1Start) {
            return '-'
          }
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const p1Start = new Date(this.dpaPeriods.p1Start.getFullYear(), this.dpaPeriods.p1Start.getMonth(), 1)
          
          if (selectedDate < p1Start) {
            return '-'
          }
          
          // Jika dalam periode P1, tampilkan data bulan tersebut
          if (this.isInP1Period) {
            return this.detailP1[field] || 0
          }
          
          // Jika dalam periode perubahan, tampilkan data dari bulan terakhir P1
          if (this.isInPerubahanPeriod) {
            return this.detailP1[field] || 0
          }
          
          return this.detailP1[field] || 0
        },
        getPerubahanValue (field) {
          // Jika bulan yang dipilih sebelum periode perubahan dimulai atau perubahan tidak ada
          if (!this.dpaPeriods || !this.dpaPeriods.perubahanStart) {
            return '-'
          }
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const perubahanStart = new Date(this.dpaPeriods.perubahanStart.getFullYear(), this.dpaPeriods.perubahanStart.getMonth(), 1)
          
          if (selectedDate < perubahanStart) {
            return '-'
          }
          
          // Jika dalam periode perubahan, tampilkan data bulan tersebut
          return this.detailPerubahan[field] || 0
        },
        // Helper untuk mendapatkan bulan yang tepat untuk fetch data
        getMurniMonthForFetch () {
          if (!this.dpaPeriods || !this.dpaPeriods.murniStart) {
            return this.filter.month
          }
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const murniStart = new Date(this.dpaPeriods.murniStart.getFullYear(), this.dpaPeriods.murniStart.getMonth(), 1)
          
          if (selectedDate < murniStart) {
            return null // Tidak ada data
          }
          
          // Jika dalam periode murni, gunakan bulan yang dipilih
          if (this.isInMurniPeriod) {
            return this.filter.month
          }
          
          // Jika tidak dalam periode murni, gunakan bulan terakhir murni
          // lastMurniMonth sudah dalam format 0-based, jadi perlu +1 untuk mendapatkan bulan 1-based
          if (this.lastMurniMonth !== null) {
            const lastMonth = this.lastMurniMonth + 1
            console.log('Bulan terakhir murni:', lastMonth, 'dari p1Date:', this.dpaPeriods.p1Start)
            return lastMonth
          }
          
          return this.filter.month
        },
        getP1MonthForFetch () {
          if (!this.dpaPeriods || !this.dpaPeriods.p1Start) {
            return null
          }
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const p1Start = new Date(this.dpaPeriods.p1Start.getFullYear(), this.dpaPeriods.p1Start.getMonth(), 1)
          
          if (selectedDate < p1Start) {
            return null // Belum masuk periode P1
          }
          
          // Jika dalam periode P1, gunakan bulan yang dipilih
          if (this.isInP1Period) {
            return this.filter.month
          }
          
          // Jika dalam periode perubahan, gunakan bulan terakhir P1
          if (this.isInPerubahanPeriod && this.lastP1Month !== null) {
            return this.lastP1Month + 1 // +1 karena getMonth() return 0-based
          }
          
          return this.filter.month
        },
        getPerubahanMonthForFetch () {
          if (!this.dpaPeriods || !this.dpaPeriods.perubahanStart) {
            return null
          }
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const perubahanStart = new Date(this.dpaPeriods.perubahanStart.getFullYear(), this.dpaPeriods.perubahanStart.getMonth(), 1)
          
          if (selectedDate < perubahanStart) {
            return null // Belum masuk periode perubahan
          }
          
          // Jika dalam periode perubahan, gunakan bulan yang dipilih
          return this.filter.month
        },
        // Helper untuk mendapatkan keterangan bulan
        getMurniInfo () {
          if (!this.dpaPeriods || !this.dpaPeriods.murniStart) {
            return 'Data belum tersedia'
          }
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const murniStart = new Date(this.dpaPeriods.murniStart.getFullYear(), this.dpaPeriods.murniStart.getMonth(), 1)
          
          if (selectedDate < murniStart) {
            return 'Data belum tersedia'
          }
          
          if (this.isInMurniPeriod) {
            return `Bulan ${this.filter.month_text} ${this.filter.year}`
          }
          
          // Jika tidak dalam periode murni, tampilkan bulan terakhir murni
          if (this.lastMurniMonth !== null) {
            const monthNames = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
            return `Bulan terakhir: ${monthNames[this.lastMurniMonth]} ${this.filter.year}`
          }
          
          return `Bulan ${this.filter.month_text} ${this.filter.year}`
        },
        getP1Info () {
          if (!this.dpaPeriods || !this.dpaPeriods.p1Start) {
            return 'Data belum tersedia'
          }
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const p1Start = new Date(this.dpaPeriods.p1Start.getFullYear(), this.dpaPeriods.p1Start.getMonth(), 1)
          
          if (selectedDate < p1Start) {
            return 'Data belum tersedia'
          }
          
          if (this.isInP1Period) {
            return `Bulan ${this.filter.month_text} ${this.filter.year}`
          }
          
          // Jika dalam periode perubahan, tampilkan bulan terakhir P1
          if (this.isInPerubahanPeriod && this.lastP1Month !== null) {
            const monthNames = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
            return `Bulan terakhir: ${monthNames[this.lastP1Month]} ${this.filter.year}`
          }
          
          return `Bulan ${this.filter.month_text} ${this.filter.year}`
        },
        getPerubahanInfo () {
          if (!this.dpaPeriods || !this.dpaPeriods.perubahanStart) {
            return 'Data belum tersedia'
          }
          const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
          const perubahanStart = new Date(this.dpaPeriods.perubahanStart.getFullYear(), this.dpaPeriods.perubahanStart.getMonth(), 1)
          
          if (selectedDate < perubahanStart) {
            return 'Data belum tersedia'
          }
          
          return `Bulan ${this.filter.month_text} ${this.filter.year}`
        },
        // Helper untuk mendapatkan nilai persentase berdasarkan periode
        getPersentasePaguAnggaran () {
          if (this.isInMurniPeriod) {
            return this.detail.sp2d_pagu_anggaran || 0
          }
          if (this.isInP1Period) {
            return this.detailP1.sp2d_pagu_anggaran || 0
          }
          if (this.isInPerubahanPeriod) {
            return this.detailPerubahan.sp2d_pagu_anggaran || 0
          }
          return 0
        },
        getPersentaseAnggaranKas () {
          if (this.isInMurniPeriod) {
            return this.detail.sp2d_anggaran || 0
          }
          if (this.isInP1Period) {
            return this.detailP1.sp2d_anggaran || 0
          }
          if (this.isInPerubahanPeriod) {
            return this.detailPerubahan.sp2d_anggaran || 0
          }
          return 0
        },
        // Helper untuk mendapatkan nilai Realisasi Keuangan berdasarkan periode
        getSp2dBulan () {
          if (this.isInMurniPeriod) {
            return this.detail.sp2d_bulan || 0
          }
          if (this.isInP1Period) {
            return this.detailP1.sp2d_bulan || 0
          }
          if (this.isInPerubahanPeriod) {
            return this.detailPerubahan.sp2d_bulan || 0
          }
          return 0
        },
        getSp2bBulan () {
          if (this.isInMurniPeriod) {
            return this.detail.sp2b_bulan || 0
          }
          if (this.isInP1Period) {
            return this.detailP1.sp2b_bulan || 0
          }
          if (this.isInPerubahanPeriod) {
            return this.detailPerubahan.sp2b_bulan || 0
          }
          return 0
        },
        getRealisasiKeuangan () {
          if (this.isInMurniPeriod) {
            return this.detail.realisasi_keuangan || 0
          }
          if (this.isInP1Period) {
            return this.detailP1.realisasi_keuangan || 0
          }
          if (this.isInPerubahanPeriod) {
            return this.detailPerubahan.realisasi_keuangan || 0
          }
          return 0
        },
        getTotalSp2bSp2d () {
          return (this.getSp2bBulan() * 1) + (this.getSp2dBulan() * 1)
        },
        getSelisihRealisasi () {
          return (this.getRealisasiKeuangan() * 1) - this.getTotalSp2bSp2d()
        },
        // Helper untuk mendapatkan nilai Program, Kegiatan, Sub Kegiatan berdasarkan periode
        getTotalProgram (period) {
          if (period === 'murni') {
            const value = this.getMurniValue('total_program')
            return value === '-' ? '-' : (value || 0)
          }
          if (period === 'p1') {
            const value = this.getP1Value('total_program')
            return value === '-' ? '-' : (value || 0)
          }
          if (period === 'perubahan') {
            const value = this.getPerubahanValue('total_program')
            return value === '-' ? '-' : (value || 0)
          }
          return '-'
        },
        getTotalKegiatan (period) {
          if (period === 'murni') {
            const value = this.getMurniValue('total_kegiatan')
            return value === '-' ? '-' : (value || 0)
          }
          if (period === 'p1') {
            const value = this.getP1Value('total_kegiatan')
            return value === '-' ? '-' : (value || 0)
          }
          if (period === 'perubahan') {
            const value = this.getPerubahanValue('total_kegiatan')
            return value === '-' ? '-' : (value || 0)
          }
          return '-'
        },
        getTotalSubKegiatan (period) {
          if (period === 'murni') {
            const value = this.getMurniValue('total_sub_kegiatan')
            return value === '-' ? '-' : (value || 0)
          }
          if (period === 'p1') {
            const value = this.getP1Value('total_sub_kegiatan')
            return value === '-' ? '-' : (value || 0)
          }
          if (period === 'perubahan') {
            const value = this.getPerubahanValue('total_sub_kegiatan')
            return value === '-' ? '-' : (value || 0)
          }
          return '-'
        },
        getOpdPkSub (row, period, field) {
          if (!row) return null
          const block = row[period]
          if (!block || typeof block !== 'object' || !Object.keys(block).length) return null
          const raw = block[field]
          if (raw === undefined || raw === null || raw === '') return null
          const n = Number(raw)
          return Number.isFinite(n) ? n : null
        }
      }
    }
  </script>
  
  <style scoped>
  /* ===== SUMMARY CARD ===== */
  .summary-card {
  border-radius: 8px;
  padding: 18px;
  background: #fff;
  /* border: 1px solid rgba(0,0,0,0.06); */
  transition: all 0.25s ease;
  position: relative;
  overflow: hidden;
}

/* .summary-card::after {
  content: '';
  position: absolute;
  right: -20px;
  top: -20px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  opacity: 0.08;
} */

.summary-item {
  display: flex;
  flex-direction: column;
}

.highlight-blue {
  color: #1976D2;
}

.highlight-orange {
  color: #FF9800;
}

.highlight-green {
  color: #4CAF50;
}

.summary-murni::after { background: #1976D2; }
.summary-p1::after { background: #FF9800; }
.summary-perubahan::after { background: #4CAF50; }

.summary-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 14px;
  /* opacity: 0.7; */
}

.summary-sub-title {
  font-size: 10px;
  margin-bottom: 4px;
  text-align: center;
}


.summary-content {
  display: flex;
  justify-content: space-between;
}

.summary-value {
  font-size: 16px;
  font-weight: 600;
  margin-top: 4px;
  text-align: center;
}

/* COLOR */
.summary-murni {
  background: rgba(25,118,210,0.05);
}

.summary-p1 {
  background: rgba(255,152,0,0.06);
}

.summary-perubahan {
  background: rgba(76,175,80,0.06);
}

/* ===== TABLE IMPROVEMENT ===== */
.opd-scroll {
  max-height: 520px;
  overflow-y: auto;
}

/* sticky header */
.opd-pk-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
}

/* zebra */
.opd-pk-table tbody tr:nth-child(even) {
  background: #fafafa;
}

/* hover */
.opd-pk-table tbody tr:hover {
  background: rgba(0,0,0,0.04);
}

/* sticky OPD column */
.opd-pk-table td:first-child,
.opd-pk-table th:first-child {
  position: sticky;
  left: 0;
  background: white;
  z-index: 1;
}

/* number align */
.opd-pk-table td {
  font-variant-numeric: tabular-nums;
}

.summary-title:nth-child(1) .summary-value {
  color: #1976D2;
}

.summary-title:nth-child(2) .summary-value {
  color: #FF9800;
}

.summary-title:nth-child(3) .summary-value {
  color: #4CAF50;
}
    .grafik_loader .v-skeleton-loader {
      min-height: 350px !important;
    }
  
    .grafik_loader .v-skeleton-loader .v-skeleton-loader__image {
      height: 350px !important;
    }
  
    .text-center {
      background: white !important;
    }
  
    /* ===== CLEAN CARD DESIGN ===== */
    .border-radius {
      border-radius: 12px !important;
      transition: all 0.2s ease !important;
      overflow: hidden;
      position: relative;
      background: #FFFFFF !important;
      border: 1px solid rgba(0, 0, 0, 0.08) !important;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
    }
  
    .border-radius:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
      border-color: rgba(0, 0, 0, 0.12) !important;
    }
  
    /* ===== CLEAN STAT CARD ===== */
    .stat-card {
      background: #FFFFFF !important;
      position: relative;
      overflow: visible;
    }
  
    /* ===== CLEAN VALUE DISPLAY ===== */
    .value-display {
      font-weight: 600 !important;
      font-size: 20px !important;
      color: #1a1a1a !important;
      letter-spacing: -0.3px;
      line-height: 1.4;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', sans-serif;
    }
  
    /* ===== CLEAN PERIOD BADGE ===== */
    .period-badge {
      border-radius: 6px !important;
      font-weight: 500 !important;
      text-transform: none;
      letter-spacing: 0.1px;
      font-size: 10px !important;
      padding: 4px 10px !important;
      box-shadow: none !important;
      border: 1px solid rgba(0, 0, 0, 0.1) !important;
      height: auto !important;
      min-height: 20px !important;
    }
  
    /* ===== CLEAN PERIOD LABEL ===== */
    .period-label {
      font-weight: 600 !important;
      font-size: 12px !important;
      text-transform: none;
      letter-spacing: 0.2px;
      position: relative;
      padding-left: 12px;
    }
  
    .period-label::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 14px;
      border-radius: 2px;
    }
  
    .period-label.murni {
      color: #1976D2 !important;
    }
  
    .period-label.murni::before {
      background: #1976D2;
    }
  
    .period-label.p1 {
      color: #FF9800 !important;
    }
  
    .period-label.p1::before {
      background: #FF9800;
    }
  
    .period-label.perubahan {
      color: #4CAF50 !important;
    }
  
    .period-label.perubahan::before {
      background: #4CAF50;
    }
  
    /* ===== CLEAN ICON CONTAINER ===== */
    .icon-container {
      width: 56px;
      height: 56px;
      border-radius: 12px;
      background: rgba(0, 0, 0, 0.03);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s ease;
    }
  
    .border-radius:hover .icon-container {
      background: rgba(0, 0, 0, 0.05);
    }
  
    /* ===== CLEAN TABLE ===== */
  
    table tr {
      transition: background-color 0.15s ease;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    }
  
    table tr:last-child {
      border-bottom: none;
    }
  
    table tr:hover {
      background: rgba(0, 0, 0, 0.02) !important;
    }
  
    table th {
      background: rgba(0, 0, 0, 0.03) !important;
      color: rgba(0, 0, 0, 0.8) !important;
      font-weight: 600 !important;
      letter-spacing: 0.2px;
      text-transform: none;
      font-size: 12px !important;
      padding: 12px 16px !important;
    }
  
    table td {
      padding: 12px 16px !important;
      vertical-align: middle;
      color: rgba(0, 0, 0, 0.8);
      font-weight: 400;
    }
  
    /* ===== CLEAN CARD TITLE ===== */
    .card-title-enhanced {
      font-weight: 600 !important;
      font-size: 15px !important;
      letter-spacing: -0.2px;
      color: #1a1a1a !important;
      line-height: 1.4;
    }
  
    /* ===== CLEAN SUBTITLE ===== */
    .card-subtitle-enhanced {
      font-size: 12px !important;
      font-weight: 400 !important;
      color: rgba(0, 0, 0, 0.6) !important;
      letter-spacing: 0.1px;
      margin-top: 4px;
    }
  
    /* ===== CLEAN DIVIDER ===== */
    .v-divider {
      border-color: rgba(0, 0, 0, 0.08) !important;
      border-width: 1px !important;
    }
  
    /* ===== CLEAN NUMBER DISPLAY ===== */
    .number-display {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', Roboto, sans-serif;
      font-weight: 600;
      letter-spacing: -0.3px;
      line-height: 1.3;
    }
  
    /* ===== CLEAN EMPTY STATE ===== */
    .empty-state {
      color: rgba(0, 0, 0, 0.35);
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
    }
  
    /* ===== CLEAN PERIOD VALUE CONTAINERS ===== */
    .boder-margin-4 {
      position: relative;
      /* margin-bottom: 24px !important; */
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    }
  
    .boder-margin-4:last-child {
      margin-bottom: 0 !important;
      border-bottom: none;
      padding-bottom: 0;
    }
  
    /* ===== FIX COLUMN SPACING ===== */
    .v-row.mx-0 {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  
    .v-col.px-3 {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
  
    /* ===== FIX PERKEMBANGAN FISIK LAYOUT ===== */
    .v-card__text.py-0 {
      padding-top: 12px !important;
      padding-bottom: 12px !important;
    }
  
    /* ===== FIX OVERLAP ISSUES ===== */
    .v-card__text + .v-card__text {
      padding-top: 0 !important;
    }
  
    /* ===== ENSURE PROPER SPACING IN COLUMNS ===== */
    .v-col .boder-margin-4 {
      min-height: 60px;
    }
  
    /* ===== FIX TEXT OVERFLOW ===== */
    .caption {
      word-wrap: break-word;
      overflow-wrap: break-word;
      line-height: 1.4;
    }
  
    /* ===== PERIOD ROW STYLING ===== */
    .period-row {
      padding-bottom: 12px;
      margin-bottom: 12px !important;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    }
  
    .period-row:last-child {
      border-bottom: none;
      margin-bottom: 0 !important;
      padding-bottom: 0;
    }
  
    /* ===== PERKEMBANGAN FISIK COLUMN HEADER ===== */
    .v-col .mb-3 {
      font-size: 16px !important;
      font-weight: 600 !important;
      color: #1a1a1a;
      margin-bottom: 20px !important;
      padding-bottom: 12px;
      border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    }
  
    /* ===== RESPONSIVE DESIGN ===== */
    @media (max-width: 960px) {
      .border-radius {
        margin-bottom: 16px;
        border-radius: 12px !important;
      }
      
      .border-radius:hover {
        transform: none;
      }
  
      .value-display {
        font-size: 18px !important;
      }
  
      .card-title-enhanced {
        font-size: 14px !important;
      }
  
      .icon-container {
        width: 48px;
        height: 48px;
      }
  
      .v-card__text {
        padding: 16px 20px !important;
      }
    }
  
    /* ===== CLEAN SCROLLBAR ===== */
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
  
    ::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.02);
    }
  
    ::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 3px;
    }
  
    ::-webkit-scrollbar-thumb:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  
    /* ===== CLEAN CARD PADDING ===== */
    .v-card {
      overflow: visible !important;
    }
  
    .v-card__text {
      padding: 12px 14px !important;
    }
  
    .v-card__text:first-child {
      padding-top: 12px !important;
      padding-bottom: 12px !important;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    }
  
    /* ===== CLEAN PERIOD SECTION ===== */
    .mb-1 {
      margin-bottom: 10px !important;
      padding-bottom: 0;
    }
  
    .text-h5 {
      margin-top: 6px !important;
      line-height: 1.4 !important;
    }
  
    /* ===== CLEAN TYPOGRAPHY ===== */
    .body-2 strong {
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
    }
  
    /* ===== CLEAN CHIP ===== */
    .v-chip {
      font-weight: 500 !important;
      height: 20px !important;
      font-size: 9px !important;
      border-radius: 4px !important;
    }
  
    /* ===== RESPONSIVE SPACING ===== */
    @media (max-width: 960px) {
      .v-card__text {
        padding: 16px 20px !important;
      }
  
      .v-card__text:first-child {
        padding-top: 20px !important;
        padding-bottom: 16px !important;
      }
    }

    .opd-pk-table-wrap {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    .opd-pk-table {
      min-width: 720px;
      border-radius: 8px;
    }

    .opd-pk-table thead th {
      white-space: nowrap;
      font-size: 12px !important;
      border-bottom: thin solid rgba(0, 0, 0, 0.08) !important;
    }

    .opd-pk-th-unit {
      vertical-align: middle !important;
      background: #fafafa;
    }

    .opd-pk-th-group {
      font-weight: 600 !important;
      letter-spacing: 0.02em;
    }

    .opd-pk-th-sub {
      font-weight: 500 !important;
      font-size: 11px !important;
      color: rgba(0, 0, 0, 0.65) !important;
    }

    .opd-pk-table tbody td {
      font-size: 13px !important;
    }

    .opd-pk-table thead th {
      font-weight: 600 !important;
      font-size: 12px !important;
      background: #f8fafc !important;
      border-bottom: 1px solid rgba(0,0,0,0.08);
    }

    /* highlight group */
    .opd-pk-murni {
      background: rgba(25,118,210,0.08) !important;
      color: #1976D2 !important;
    }

    .opd-pk-p1 {
      background: rgba(255,152,0,0.08) !important;
      color: #FF9800 !important;
    }

    .opd-pk-perubahan {
      background: rgba(76,175,80,0.08) !important;
      color: #4CAF50 !important;
    }

    .opd-pk-total-row td {
      background: #f5f5f5 !important;
      border-top: 2px solid rgba(0, 0, 0, 0.1) !important;
    }

    .section-header {
      background: linear-gradient(to right, #f8fafc, #ffffff);
      border-radius: 12px;
    }

    .v-card__text {
      padding: 20px 24px !important;
    }

    .opd-pk-table tbody tr {
      transition: all 0.2s ease;
    }

    .opd-pk-table tbody tr:hover {
      background: #eef5ff !important;
    }
  </style>